<template>
  <section class="roadmap">
    <b-container fluid class="roadmap-content">
      <b-row>
        <b-col class="col-title">
          <img
            src="../../assets/rebrand/home/roadmap.png"
            alt="title roadmap"
            class="title-roadmap"
          />
        </b-col>
      </b-row>
      <!-- <b-row class=" -mb">
        <b-col sm="9" lg="7" class="mx-auto">
          <img
            src="../../assets/rebrand/home/q3-2021-view.png"
            alt="q3 2021"
            class="roadmap-view img-fluid"
          />
        </b-col>
      </b-row> -->
      <b-row>
        <b-col>
          <div class="roadmap-tab-container">
            <nav class="roadmap-nav-wrapper" v-dragscroll="false">
              <ul class="nav nav-tabs ">
                <li class="active">
                  <span data-toggle="tab" href="#conviction"></span>
                  <a>
                    <img
                      src="../../assets/rebrand/home/roadmap/q3-1-active.png"
                      alt="q3"
                      class="q3-1 active"
                      data-toggle="tab"
                      href="#conviction"
                    />
                    <img
                      src="../../assets/rebrand/home/roadmap/q3-1.png"
                      alt="q3"
                      class="q3-1"
                      data-toggle="tab"
                      href="#conviction"
                    />
                    <h5 class="number" data-toggle="tab" href="#conviction">01</h5>
                    <div class="text-container" data-toggle="tab" href="#conviction">
                      <p class="q3" data-toggle="tab" href="#conviction">Q3 2021</p>
                      <p class="title" data-toggle="tab" href="#conviction">CONVICTION</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#espn"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#espn"
                      src="../../assets/rebrand/home/roadmap/q3-2.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#espn"
                      src="../../assets/rebrand/home/roadmap/q3-2-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#espn" class="number">02</h5>
                    <div data-toggle="tab" href="#espn" class="text-container">
                      <p data-toggle="tab" href="#espn" class="q3">Q3 2021</p>
                      <p data-toggle="tab" href="#espn" class="title">ESPN x ADIDAS</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#academy"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#academy"
                      src="../../assets/rebrand/home/roadmap/q4-3.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#academy"
                      src="../../assets/rebrand/home/roadmap/q4-3-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#academy" class="number">03</h5>
                    <div data-toggle="tab" href="#academy" class="text-container">
                      <p class="q3">Q4 2021</p>
                      <p class="title">SNKRHUD ACADEMY</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#sidekicks"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#sidekicks"
                      src="../../assets/rebrand/home/roadmap/q2-4.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#sidekicks"
                      src="../../assets/rebrand/home/roadmap/q2-4-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#sidekicks" class="number">04</h5>
                    <div data-toggle="tab" href="#sidekicks" class="text-container">
                      <p class="q3">Q2 2022</p>
                      <p class="title">SIDE KICKS</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#nftnyc"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#nftnyc"
                      src="../../assets/rebrand/home/roadmap/q2-5.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#nftnyc"
                      src="../../assets/rebrand/home/roadmap/q2-5-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#nftnyc" class="number">05</h5>
                    <div data-toggle="tab" href="#nftnyc" class="text-container">
                      <p class="q3">Q3 2022</p>
                      <p class="title">NFT NYC</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#applaunch"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#applaunch"
                      src="../../assets/rebrand/home/roadmap/q3-6.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#applaunch"
                      src="../../assets/rebrand/home/roadmap/q3-6-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#applaunch" class="number">06</h5>
                    <div data-toggle="tab" href="#applaunch" class="text-container">
                      <p class="q3">Q2 2022</p>
                      <p class="title">APP LAUNCH</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#dedstock"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#dedstock"
                      src="../../assets/rebrand/home/roadmap/q3-7.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#dedstock"
                      src="../../assets/rebrand/home/roadmap/q3-7-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#dedstock" class="number">07</h5>
                    <div data-toggle="tab" href="#dedstock" class="text-container">
                      <p class="q3">Q3 2022</p>
                      <p class="title">DED STOCK</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#merch"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#merch"
                      src="../../assets/rebrand/home/roadmap/q3-8.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#merch"
                      src="../../assets/rebrand/home/roadmap/q3-8-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#merch" class="number">08</h5>
                    <div data-toggle="tab" href="#merch" class="text-container">
                      <p class="q3">Q3 2022</p>
                      <p class="title">MERCH</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#retail"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#retail"
                      src="../../assets/rebrand/home/roadmap/q4-9.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#retail"
                      src="../../assets/rebrand/home/roadmap/q4-9-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#retail" class="number">09</h5>
                    <div data-toggle="tab" href="#retail" class="text-container">
                      <p class="q3">Q4 2022</p>
                      <p class="title">RETAIL PARTNERSHIP</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#faction"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#faction"
                      src="../../assets/rebrand/home/roadmap/q4-10.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#faction"
                      src="../../assets/rebrand/home/roadmap/q4-10-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#faction" class="number">10</h5>
                    <div data-toggle="tab" href="#faction" class="text-container">
                      <p class="q3">Q4 2022</p>
                      <p class="title">FACTION 2</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#p2e"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#p2e"
                      src="../../assets/rebrand/home/roadmap/q4-11.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#p2e"
                      src="../../assets/rebrand/home/roadmap/q4-11-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#p2e" class="number">11</h5>
                    <div data-toggle="tab" href="#p2e" class="text-container">
                      <p class="q3">Q4 2022</p>
                      <p class="title">P2E</p>
                    </div>
                  </a>
                </li>

                <li>
                  <span data-toggle="tab" href="#airdrops"></span>
                  <a>
                    <img
                      data-toggle="tab"
                      href="#airdrops"
                      src="../../assets/rebrand/home/roadmap/q2-12.png"
                      alt="q3"
                      class="q3-1"
                    />
                    <img
                      data-toggle="tab"
                      href="#airdrops"
                      src="../../assets/rebrand/home/roadmap/q2-12-active.png"
                      alt="q3"
                      class="q3-1 active"
                    />
                    <h5 data-toggle="tab" href="#airdrops" class="number">12</h5>
                    <div data-toggle="tab" href="#airdrops" class="text-container">
                      <p class="q3">Q4 2022</p>
                      <p class="title">AIRDROPS</p>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>

            <div class="tab-content">
              <div id="conviction" class="tab-pane fade in active">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q3 2021</h1>
                    <hr />
                    <p class="desc">
                      Proved our Community is interested in Creating their own NFT's through our
                      beta version of the SNKRHUD app
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="espn" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q3 2021</h1>
                    <hr />
                    <p class="desc">
                      Helped bring the Adidas Top Ten High ESPN to market through an in-app
                      collaboration with our Community
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="academy" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q4 2022</h1>
                    <hr />
                    <p class="desc">
                      Started a platform to educate on the basics of NFT's: <br />
                      1) What are they? <br />
                      2) Where can I find them? <br />
                      3) What can I do with them?
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="sidekicks" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q2 2022</h1>
                    <hr />
                    <p class="desc">
                      Minting first faction of 4280 Meerkats and giving away an additional 1000 to
                      new wallet holders
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="nftnyc" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q3 2022</h1>
                    <hr />
                    <p class="desc">
                      Pack your bags with your flyest rotation because the hottest party at NFT NYC
                      will be exclusive to Side Kicks & DED Stock Holders
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="applaunch" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q2 2022</h1>
                    <hr />
                    <p class="desc">
                      Shortly after mint, the SNKRHUD app will be available to all Side Kicks
                      Holders on iOS and Android
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="dedstock" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q3 2022</h1>
                    <hr />
                    <p class="desc">
                      Experience a new way to interact with and monetize your sneaker collection by
                      Creating DED Stock (Digitally Enabled Dopeness)
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="merch" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q3 2022</h1>
                    <hr />
                    <p class="desc">
                      Flex on every other NFT project with merch dropping first at NFT NYC and
                      online for those who can't attend
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="retail" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q4 2022</h1>
                    <hr />
                    <p class="desc">
                      Limited DED Stock giveaways dropping in collaboration with your favorite
                      sneaker boutiques
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="faction" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q4 2022</h1>
                    <hr />
                    <p class="desc">Where will the next faction of heroes come online next?</p>
                  </div>
                </b-col>
              </div>

              <div id="p2e" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q4 2022</h1>
                    <hr />
                    <p class="desc">
                      Utilize your DED Stock, whether based on sneakers you own or purchased from
                      others, to Compete in Battles and earn $CRED
                    </p>
                  </div>
                </b-col>
              </div>

              <div id="airdrops" class="tab-pane fade">
                <b-col class="mx-auto">
                  <div class="highlight-content">
                    <h1 class="title">Q4 2022</h1>
                    <hr />
                    <p class="desc">
                      All Side Kick Holders will receive a Faction Badge shortly after mint,
                      followed by additional airdrops in collaboration with top NFT & Sneaker brands
                    </p>
                  </div>
                </b-col>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- <b-container fluid class="npd  -mb">
      <b-row>
        <b-col>
          <div class="roadmaps-list" v-dragscroll="true">
            <img src="../../assets/mobile/roadmaps1.png" alt="roadmaps" class="roadmaps -mb" />
          </div>
        </b-col>
      </b-row>
    </b-container> -->
    <!-- <img src="../../assets/mobile/roadmap-overlay.png" alt="roadmaps" class="roadmap-overlay -mb" /> -->
  </section>
</template>
<script>
import { dragscroll } from 'vue-dragscroll';

export default {
  name: 'Roadmap',
  directives: {
    dragscroll,
  },
};
</script>
